import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["children"];
import React, { Component } from 'react';
import BreadcrumbsContext from '../BreadcrumbsContext';
import BreadcrumbsItemInner from './BreadcrumbsItemInner';
export default class BreadcrumbsItem extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "render", () => {
      const _this$props = this.props,
        {
          children
        } = _this$props,
        breadcrumbItemProps = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(BreadcrumbsContext.Consumer, null, _ref => {
        let {
          clearBreadcrumbItems,
          updateBreadcrumbItems
        } = _ref;
        return /*#__PURE__*/React.createElement(BreadcrumbsItemInner, _extends({}, breadcrumbItemProps, {
          clearBreadcrumbItems: clearBreadcrumbItems,
          updateBreadcrumbItems: updateBreadcrumbItems
        }), children);
      });
    });
  }
}